// 使用 localStorage 寄存缓存(pro pref: 使用SSR服务器语言渲染静态页面时，将缓存器寄存于服务端)
import Cache from '@/support/cache'
import { createI18n } from 'vue-i18n'
import type { Language } from 'element-plus'

import zh from './languages/zh'
import en from './languages/en'

import zhCn from 'element-plus/es/locale/lang/zh-cn'
import enUs from 'element-plus/es/locale/lang/en'

export const LANGUAGE_KEY = 'language'
export const DEFAULT_LANGUAGE = 'zh'
export const SUPPORT_LANGUAGES = ['zh', 'en'] as const

export type AppLanguage = (typeof SUPPORT_LANGUAGES)[number]

// 业务国际化文案
export const messages = {
  zh,
  en
}

// Element Plus 国际化包
export const elementLocales: Record<AppLanguage, Language> = {
  zh: zhCn,
  en: enUs
}

// 安全获取语言，避免 localStorage 中出现非法值
export function getStoredLanguage(): AppLanguage {
  const lang = Cache.get(LANGUAGE_KEY)
  if (lang && SUPPORT_LANGUAGES.includes(lang as AppLanguage)) {
    return lang as AppLanguage
  }
  return DEFAULT_LANGUAGE
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getStoredLanguage(),
  fallbackLocale: DEFAULT_LANGUAGE,
  messages
})

export default i18n
